import React from "react";
import { FormField, CardSection, CheckboxItem } from "../../Common/FormComponents";

const PROPERTY_TYPE_OPTIONS = [
  { value: "", label: "Select property type" },
  { value: "house", label: "House" },
  { value: "apartment", label: "Apartment" },
  { value: "condo", label: "Condo" },
  { value: "townhouse", label: "Townhouse" },
  { value: "duplex", label: "Duplex" },
  { value: "commercial", label: "Commercial" },
  { value: "land", label: "Land" },
];

const AMENITIES_OPTIONS = [
  { value: "parking", label: "Parking" },
  { value: "garage", label: "Garage" },
  { value: "pool", label: "Pool" },
  { value: "gym", label: "Gym" },
  { value: "laundry", label: "Laundry" },
  { value: "dishwasher", label: "Dishwasher" },
  { value: "air_conditioning", label: "Air Conditioning" },
  { value: "heating", label: "Heating" },
  { value: "fireplace", label: "Fireplace" },
  { value: "balcony", label: "Balcony" },
  { value: "garden", label: "Garden" },
  { value: "pet_friendly", label: "Pet Friendly" },
  { value: "utilities_included", label: "Utilities Included" },
  { value: "internet", label: "Internet" },
  { value: "doorman", label: "Doorman" },
  { value: "hot_cold", label: "Hot & Cold" },
  { value: "semi_furnished", label: "Semi-furnished" },
  { value: "full_furnished", label: "Full-furnished" },
  { value: "unfurnished", label: "Unfurnished" },
];

const PropertyDetailsSection = ({ formData, handleInputChange, handleAmenitiesChange }) => {
  const isLand = formData.propertyType === "land";

  return (
    <>
      <CardSection title="Property Details">
        <p style={{ fontSize: 12, color: "#6b7280", marginBottom: "0.75rem", lineHeight: 1.6 }}>
          Select the <strong>physical property type</strong> first. Bedrooms and bathrooms apply to
          structures; they are hidden when the type is <strong>land</strong>.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
            gap: "0.75rem",
          }}
        >
          <div style={{ gridColumn: "1 / -1" }}>
            <FormField
              label="Physical property type"
              name="propertyType"
              type="select"
              value={formData.propertyType}
              onChange={handleInputChange}
              required
              options={PROPERTY_TYPE_OPTIONS}
            />
          </div>
          {!isLand ? (
            <>
              <FormField
                label="Bedrooms"
                name="bedrooms"
                type="number"
                value={formData.bedrooms}
                onChange={handleInputChange}
                min="0"
                required
                placeholder="0"
              />
              <FormField
                label="Bathrooms"
                name="bathrooms"
                type="number"
                value={formData.bathrooms}
                onChange={handleInputChange}
                min="0"
                step="0.5"
                required
                placeholder="0"
              />
              <FormField
                label="Property sq ft"
                name="squareFootage"
                type="number"
                value={formData.squareFootage}
                onChange={handleInputChange}
                min="0"
                required
                placeholder="0"
              />
              <FormField
                label="Land sq ft (optional)"
                name="lotSize"
                type="number"
                value={formData.lotSize}
                onChange={handleInputChange}
                min="0"
                placeholder="0"
              />
              <FormField
                label="Year built (optional)"
                name="yearBuilt"
                type="number"
                value={formData.yearBuilt}
                onChange={handleInputChange}
                min="1800"
                max={new Date().getFullYear()}
                placeholder="YYYY"
              />
            </>
          ) : (
            <>
              <FormField
                label="Land sq ft"
                name="lotSize"
                type="number"
                value={formData.lotSize}
                onChange={handleInputChange}
                min="0"
                required
                placeholder="0"
              />
              <FormField
                label="Property sq ft (optional)"
                name="squareFootage"
                type="number"
                value={formData.squareFootage}
                onChange={handleInputChange}
                min="0"
                placeholder="If applicable"
              />
              <FormField
                label="Year built (optional)"
                name="yearBuilt"
                type="number"
                value={formData.yearBuilt}
                onChange={handleInputChange}
                min="1800"
                max={new Date().getFullYear()}
                placeholder="YYYY"
              />
            </>
          )}
        </div>
      </CardSection>

      <CardSection title="Property Amenities">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
            gap: "0.625rem",
          }}
        >
          {AMENITIES_OPTIONS.map((amenity) => (
            <CheckboxItem
              key={amenity.value}
              id={`property-amenity-${amenity.value}`}
              label={amenity.label}
              value={amenity.value}
              checked={formData.amenities?.includes(amenity.value)}
              onChange={handleAmenitiesChange}
            />
          ))}
        </div>
      </CardSection>
    </>
  );
};

export default PropertyDetailsSection;
